import { Badge, Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { UserAvatarMenu } from './modules/UserAvatarMenu';
import { HeaderItems } from './HeaderItems';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping } from '@fortawesome/pro-light-svg-icons';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

import { withShowable } from '../../../_global/lib/withShowable';
import { REDACTED_FIELD } from '../../../../config/logrocket';
import { useCart } from '../../../../policyholders/resilience/features/self-serve/hooks/useCart';
import { FEATURE_FLAG_KEYS } from '../../../../config/growthbook';

interface Props {
  account: any;
}

const InsuredMainHeader = ({ account }: Props) => {
  const { data: cart } = useCart();
  const crsEnableSelfServe = useFeatureIsOn(
    FEATURE_FLAG_KEYS.CRS_ENABLE_SELF_SERVE
  );

  return (
    <HeaderItems>
      {crsEnableSelfServe && (
        <Link to="/customer/resilience/cart">
          <Badge
            badgeContent={cart?.cartItems?.length ?? 0}
            color="info"
            showZero={false}
          >
            <FontAwesomeIcon icon={faCartShopping} size="2x" />
          </Badge>
        </Link>
      )}

      <Box>
        <Typography className={`${REDACTED_FIELD} tertia-text`}>
          {account.name}
        </Typography>
      </Box>

      <Box>
        <UserAvatarMenu />
      </Box>
    </HeaderItems>
  );
};

export default withShowable(InsuredMainHeader);
